export interface Language {
  code: string;
  name: string;
  nativeName: string;
  flag: string;
}

export const SUPPORTED_LANGUAGES: Language[] = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '\u{1F1EC}\u{1F1E7}' },
  { code: 'fr', name: 'French', nativeName: 'Fran\u00e7ais', flag: '\u{1F1EB}\u{1F1F7}' },
  { code: 'es', name: 'Spanish', nativeName: 'Espa\u00f1ol', flag: '\u{1F1EA}\u{1F1F8}' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '\u{1F1E9}\u{1F1EA}' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Portugu\u00eas', flag: '\u{1F1F5}\u{1F1F9}' },
];

export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGE_STORAGE_KEY = 'preferred-language';

export const MANUAL_FLAG_KEY = 'language-manually-set';

/**
 * Map country codes (ISO 3166-1 alpha-2) to language codes.
 * Only countries where the primary language matches a supported language.
 */
export const COUNTRY_TO_LANGUAGE: Record<string, string> = {
  // French-speaking
  FR: 'fr', BE: 'fr', CD: 'fr', CI: 'fr', SN: 'fr', CM: 'fr',
  ML: 'fr', BF: 'fr', NE: 'fr', TD: 'fr', GN: 'fr', RW: 'fr',
  HT: 'fr', TG: 'fr', BJ: 'fr', MG: 'fr', GA: 'fr', CG: 'fr',
  DJ: 'fr', CF: 'fr', KM: 'fr', MC: 'fr', LU: 'fr',
  // Spanish-speaking
  ES: 'es', MX: 'es', CO: 'es', AR: 'es', PE: 'es', VE: 'es',
  CL: 'es', EC: 'es', GT: 'es', CU: 'es', BO: 'es', DO: 'es',
  HN: 'es', PY: 'es', SV: 'es', NI: 'es', CR: 'es', PA: 'es',
  UY: 'es', PR: 'es', GQ: 'es',
  // German-speaking
  DE: 'de', AT: 'de', CH: 'de', LI: 'de',
  // Portuguese-speaking
  BR: 'pt', PT: 'pt', AO: 'pt', MZ: 'pt', GW: 'pt', TL: 'pt',
  CV: 'pt', ST: 'pt',
};

/**
 * Map language codes to locale strings for Intl APIs.
 */
export const LANGUAGE_TO_LOCALE: Record<string, string> = {
  en: 'en-US',
  fr: 'fr-FR',
  es: 'es-ES',
  de: 'de-DE',
  pt: 'pt-BR',
};
